import { IBaseIconProps } from "./IBaseIconProps";

/** A closed padlock — "you can see this, but you can't open it". */
export const LockIcon = ({ color = "#ffffff" }: IBaseIconProps) => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="5.5" y="10.5" width="13" height="10" rx="2" />
      <path d="M8.5 10.5V7.5a3.5 3.5 0 0 1 7 0v3" />
      <path d="M12 14.6v2" />
    </svg>
  );
};
